import { postReviewAutomationResponse as postResponseAPI } from 'src/common/Scraper';

/**
 * Posts a review automation response draft via API.
 *
 * @param responseId - The response document ID (_id)
 * @param payload - Payload containing action and draft
 * @returns Promise resolving to API response
 */
export const postReviewAutomationResponse = (
  responseId: string,
  payload: { action: string; draft: string }
): Promise<any> => {
  return postResponseAPI(responseId, payload);
};

export default postReviewAutomationResponse;
